var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTestIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_13038",
    "data-name": "Group 13038",
    transform: "translate(0 -0.112)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11823",
    "data-name": "Group 11823",
    transform: "translate(10.059 10.089)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_163",
    "data-name": "Path 163",
    d: "M40.391,267.627a3.88,3.88,0,0,1-3.877-3.876V247.079a8.069,8.069,0,0,1,8.059-8.058,1.044,1.044,0,0,1,0,2.088,5.976,5.976,0,0,0-5.971,5.97v16.673a1.788,1.788,0,1,0,3.576,0V250.727a1.044,1.044,0,0,1,2.088,0v13.024A3.88,3.88,0,0,1,40.391,267.627Z",
    transform: "translate(-11.104 -221.584)",
    fill: "#2eafbe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_164",
    "data-name": "Path 164",
    d: "M49.828,287.447H41.421a1.044,1.044,0,0,1-1.044-1.044V259.061a1.044,1.044,0,0,1,2.088,0v26.3h6.319V256.193a1.044,1.044,0,0,1,2.088,0V286.4A1.044,1.044,0,0,1,49.828,287.447Z",
    transform: "translate(-9.303 -214.063)",
    fill: "#2eafbe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_165",
    "data-name": "Path 165",
    d: "M56.148,267.692a3.881,3.881,0,0,1-3.876-3.877V250.792a1.043,1.043,0,1,1,2.087,0v13.023a1.789,1.789,0,0,0,3.578,0V247.142a5.978,5.978,0,0,0-5.971-5.971,1.043,1.043,0,0,1,0-2.087,8.067,8.067,0,0,1,8.058,8.058v16.673A3.881,3.881,0,0,1,56.148,267.692Z",
    transform: "translate(-4.384 -221.555)",
    fill: "#2eafbe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_166",
    "data-name": "Path 166",
    d: "M55.561,287.418H47.154a1.044,1.044,0,0,1-1.044-1.044V256.256a1.044,1.044,0,0,1,2.088,0v29.075h6.319V259.125a1.043,1.043,0,1,1,2.087,0v27.248A1.042,1.042,0,0,1,55.561,287.418Z",
    transform: "translate(-6.629 -214.033)",
    fill: "#2eafbe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_167",
    "data-name": "Path 167",
    d: "M49.167,241.873a7.371,7.371,0,1,1,7.371-7.371A7.381,7.381,0,0,1,49.167,241.873Zm0-12.656a5.284,5.284,0,1,0,5.285,5.285A5.29,5.29,0,0,0,49.167,229.217Z",
    transform: "translate(-8.642 -227.13)",
    fill: "#2eafbe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_168",
    "data-name": "Path 168",
    d: "M36.541,279.238c-.035,0-.072,0-.109-.006L20.12,277.506a1.044,1.044,0,0,1-.868-1.4l5.773-15.353a1.044,1.044,0,0,1,1.865-.182l2.147,3.481,11.8-7.279a1.043,1.043,0,1,1,1.1,1.774l-12.686,7.829a1.043,1.043,0,0,1-1.436-.34l-1.579-2.559-4.549,12.1,12.854,1.361-1.579-2.559a1.044,1.044,0,0,1,.34-1.437l14.18-8.75a1.043,1.043,0,1,1,1.1,1.774l-13.293,8.2,2.148,3.48a1.044,1.044,0,0,1-.889,1.593Z",
    transform: "translate(-19.186 -213.38)",
    fill: "#2eafbe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_169",
    "data-name": "Path 169",
    d: "M41.245,257.575a1.022,1.022,0,0,1-.547-.157l-11.661-7.194-2.147,3.481a1.044,1.044,0,0,1-1.865-.182L19.252,238.17a1.044,1.044,0,0,1,.868-1.4l16.312-1.726a1.044,1.044,0,0,1,1,1.587l-2.148,3.48,6.65,4.1a1.043,1.043,0,0,1-1.1,1.776L33.3,241.335a1.039,1.039,0,0,1-.468-.648,1.05,1.05,0,0,1,.128-.789l1.579-2.559L21.682,238.7l4.549,12.1,1.579-2.559a1.042,1.042,0,0,1,1.436-.34l12.549,7.744a1.044,1.044,0,0,1-.55,1.931Z",
    transform: "translate(-19.186 -223.444)",
    fill: "#2eafbe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_170",
    "data-name": "Path 170",
    d: "M66.606,279.238a1.045,1.045,0,0,1-.889-1.593l2.15-3.48-13.293-8.2a1.043,1.043,0,1,1,1.1-1.774l14.18,8.75a1.046,1.046,0,0,1,.34,1.437l-1.581,2.559,12.856-1.361-4.549-12.1-1.579,2.559a1.044,1.044,0,0,1-1.437.34l-12.686-7.829a1.043,1.043,0,1,1,1.1-1.774l11.8,7.279,2.148-3.481a1.044,1.044,0,0,1,1.865.182L83.9,276.1a1.044,1.044,0,0,1-.868,1.4l-16.312,1.726C66.679,279.235,66.643,279.238,66.606,279.238Z",
    transform: "translate(-2.912 -213.38)",
    fill: "#2eafbe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_171",
    "data-name": "Path 171",
    d: "M59.791,257.575a1.043,1.043,0,0,1-.55-1.931L71.789,247.9a1.043,1.043,0,0,1,1.437.34l1.579,2.559,4.549-12.1L66.5,237.339l1.581,2.559a1.046,1.046,0,0,1-.342,1.437L60.2,245.987a1.043,1.043,0,1,1-1.1-1.776l6.65-4.1-2.15-3.48a1.045,1.045,0,0,1,1-1.587l16.312,1.726a1.044,1.044,0,0,1,.868,1.4l-5.773,15.353a1.044,1.044,0,0,1-1.865.182L72,250.224l-11.659,7.194A1.029,1.029,0,0,1,59.791,257.575Z",
    transform: "translate(-0.8 -223.444)",
    fill: "#2eafbe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_172",
    "data-name": "Path 172",
    d: "M75.927,277.839H32.266a1.043,1.043,0,0,1,0-2.087H75.927a1.043,1.043,0,1,1,0,2.087Z",
    transform: "translate(-13.572 -204.454)",
    fill: "#2eafbe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_173",
    "data-name": "Path 173",
    d: "M85.251,282.973H27.442a1.044,1.044,0,0,1,0-2.088H85.251a1.044,1.044,0,1,1,0,2.088Z",
    transform: "translate(-15.822 -202.06)",
    fill: "#2eafbe"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1007",
    "data-name": "Rectangle 1007",
    width: 100,
    height: 100,
    transform: "translate(0 0.112)",
    fill: "none"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTestIcon);
export default __webpack_public_path__ + "static/media/test-icon.79e32c0574361d82e5998578cd2f814b.svg";
export { ForwardRef as ReactComponent };